import { PaymentType } from 'models'
import { AllPaymentTypeOptions, PaymentTypeOptions } from './constants'
import { POSProduct, ProductWithPlans, Plan, OLIDetail } from 'models/productsV3.model'

export const combineProductsList = ({
  productsList,
  selectedProductsList,
}: {
  productsList: POSProduct[]
  selectedProductsList: OLIDetail[]
}) => {
  if (productsList?.length > 0) {
    const list = productsList.map((product) => {
      const planSummary = selectedProductsList?.filter((selected) => {
        return selected?.posReferenceId === product?.sfReferenceId
      })
      return { ...product, planSummary }
    })

    return list
  }
  return productsList
}

export const getAdditionalPlanSummay = (olis: OLIDetail[]) => {
  return olis.reduce(
    (text, pos) => {
      text.totalPlans += pos.quantity
      text.plansSummary.push(`${pos.quantity} x ${pos.name} `)
      return text
    },
    { totalPlans: 0, plansSummary: [] },
  )
}

export const combinePlansList = ({
  allPlans,
  selectedPlans,
}: {
  allPlans: Plan[]
  selectedPlans: Plan[]
}) => {
  const planMap = new Map<string, Plan>()
  if (selectedPlans) {
    selectedPlans.forEach((plan) => {
      planMap.set(plan.planId, { ...plan })
    })
  }
  if (allPlans) {
    allPlans.forEach((plan) => {
      if (!planMap.has(plan.planId)) {
        planMap.set(plan.planId, { ...plan, quantity: 0 })
      } else {
        const existingPlan = planMap.get(plan.planId)
        planMap.set(plan.planId, { ...existingPlan, ...plan })
      }
    })
  }
  return planMap
}

export const extractAllSelectedPlans = (productWithPlansList: ProductWithPlans[]) => {
  if (productWithPlansList?.length === 0) {
    return []
  }
  return productWithPlansList.reduce(
    (acc, product) => acc.concat(product?.plans || []),
    [] as Plan[],
  )
}

export const getPaymentTypeString = (paymentType: PaymentType) =>
  AllPaymentTypeOptions.find(({ key }) => key === paymentType)?.value ||
  AllPaymentTypeOptions[0].value

export const getPaymentTypeKey = (paymentType: string) =>
  AllPaymentTypeOptions.find(({ value }) => value === paymentType)?.key
